module.exports = __webpack_public_path__ + "static/img/05.2b4e034.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotkeSlider/05.jpg
// module id = b8wM
// module chunks = 0